import { createContext, useContext } from "react";

export const UserContext = createContext({
    geoAccepted: false,
});

export function useUser() {
    return useContext(UserContext);
}
